<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <BaseCheckbox
          v-model="formData.settings.sales.thermalSupport"
          :label="$t('admin.invoices.permissions.support_thermal_printer')"
          v-test="'thermalSupport'"
        />
        <BaseCheckbox
          v-model="formData.settings.sales.showVatOnInvoice"
          :label="$t('admin.invoices.permissions.show_vat_amount')"
          v-test="'showVatOnInvoice'"
        />
        <BaseCheckbox
          v-model="formData.settings.sales.showTreatmentDateOnInvoice"
          :label="$t('admin.invoices.permissions.show_treatment_date')"
          v-test="'showTreatmentDateOnInvoice'"
        />
        <BaseCheckbox
          v-model="formData.settings.sales.printNextAppointment"
          :disabled="!formData.settings.sales.thermalSupport"
          :label="$t('admin.invoices.permissions.print_date_of_next_apppintment')"
          v-test="'printNextAppointment'"
        />
        <BaseAlert
          v-if="!hasPaymentProvider"
          :text="$t('admin.invoices.permissions.payment_link_alert')"
          color="warning"
          :primaryAction="{
            text: $t('nav.integrations'),
            routerLink: { name: 'integrations' }
          }"
          v-test="'payment-provider-alert'"
        />
        <BaseCheckbox
          v-model="formData.settings.sales.paymentLink"
          :disabled="!hasPaymentLink"
          :label="$t('admin.invoices.permissions.payment_link')"
          v-test="'paymentLink'"
        />
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import type { Ref } from 'vue';
import { inject } from 'vue';
import type { InvoiceFormData } from './useInvoices';

const formData = inject<InvoiceFormData>('formData')!;
const hasPaymentProvider = inject<Ref<boolean>>('hasPaymentProvider')!;
const hasPaymentLink = inject<Ref<boolean>>('hasPaymentLink')!;
</script>
